import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { authService } from '@/services/api';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import ApiKeys from '@/pages/ApiKeys';
import Documentation from '@/pages/Documentation';
import Settings from '@/pages/Settings';
import Projects from '@/pages/Projects';
import ProjectDetails from '@/pages/ProjectDetails';
import Wallets from '@/pages/Wallets';
import Congregations from '@/pages/Congregations';
import LedgerStatement from '@/pages/LedgerStatement';
import Orders from '@/pages/Orders';
import Transfers from '@/pages/Transfers';
import PaymentGateway from '@/pages/PaymentGateway';
import SuperAdmin from '@/pages/SuperAdmin';
import Webhooks from '@/pages/Webhooks';
import ApiHealth from '@/pages/ApiHealth';
import PlatformGuide from '@/pages/PlatformGuide';
import MerchantGuide from '@/pages/MerchantGuide';
import "@/App.css";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public Route (redirect if authenticated)
const PublicRoute = ({ children }) => {
  if (authService.isAuthenticated()) {
    const user = authService.getCurrentUser();
    if (user?.role === 'super_admin') {
      return <Navigate to="/super-admin" replace />;
    }
    if (user?.role === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          <Route 
            path="/register" 
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            } 
          />
          
          {/* Payment Gateway - Public route (no authentication) */}
          <Route 
            path="/pay/:orderId" 
            element={<PaymentGateway />}
          />

          {/* Platform Guide - Own authentication */}
          <Route path="/platform-guide" element={<PlatformGuide />} />

          {/* Merchant Guide - Public */}
          <Route path="/guia-comercios" element={<MerchantGuide />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api-keys"
            element={
              <ProtectedRoute>
                <ApiKeys />
              </ProtectedRoute>
            }
          />
          {/* Documentation - Public route for merchants */}
          <Route
            path="/documentation"
            element={<Documentation />}
          />
          <Route
            path="/docs"
            element={<Documentation />}
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transfers"
            element={
              <ProtectedRoute>
                <Transfers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:projectId"
            element={
              <ProtectedRoute>
                <ProjectDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wallets"
            element={
              <ProtectedRoute>
                <Wallets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/congregations"
            element={
              <ProtectedRoute>
                <Congregations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ledger"
            element={
              <ProtectedRoute>
                <LedgerStatement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
          
          {/* Super Admin Route */}
          <Route
            path="/super-admin"
            element={
              <ProtectedRoute>
                <SuperAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/webhooks"
            element={
              <ProtectedRoute>
                <Webhooks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/integration-health"
            element={
              <ProtectedRoute>
                <ApiHealth />
              </ProtectedRoute>
            }
          />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
